import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _approveJoinGroupRequestsRequest = {};
var _approveJoinGroupRequestsResponse = {
    joinGroupRequests: '_joinGroupRequest',
};
var _cancelJoinGroupRequestRequest = {};
var _cancelJoinGroupRequestResponse = {
    joinGroupRequest: '_joinGroupRequest',
};
var _joinGroupRequest = { createdDate: 'google.protobuf.Timestamp' };
var _listJoinGroupRequestsRequest = {};
var _listJoinGroupRequestsResponse = {
    joinGroupRequests: '_joinGroupRequest',
};
var _queryJoinGroupRequestsRequest = {};
var _queryJoinGroupRequestsResponse = {
    joinGroupRequests: '_joinGroupRequest',
};
var _rejectJoinGroupRequestsRequest = {};
var _rejectJoinGroupRequestsResponse = {
    joinGroupRequests: '_joinGroupRequest',
};
var _submitJoinGroupRequestRequest = {};
var _submitJoinGroupRequestResponse = {
    joinGroupRequest: '_joinGroupRequest',
};
function resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/social-groups-server',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        'groups.wixapps.net': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/social-groups-web',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/social-groups/api',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups',
                destPath: '/api',
            },
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
        'editor-flow.wixapps.net': [
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/social-groups/v2',
                destPath: '/v2',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/social-groups/v2',
                destPath: '/v2',
            },
            {
                srcPath: '/_api/social-groups/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/social-groups/api/v1',
                destPath: '/api/v1',
            },
            {
                srcPath: '/_api/social-groups/api/v1',
                destPath: '/api/v1',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * Submits a join group request.
 * Relevant only for private groups.
 */
export function submitJoinGroupRequest(payload) {
    return function __submitJoinGroupRequest(_a) {
        var host = _a.host;
        var toJSON = serializer(_submitJoinGroupRequestRequest, {}).toJSON;
        var fromJSON = serializer(_submitJoinGroupRequestResponse, {
            _joinGroupRequest: _joinGroupRequest,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl({
                protoPath: '/v2/groups/{groupId}/join-requests',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Cancels a join group request.
 * A site member can cancel only their own pending Join group requests.
 */
export function cancelJoinGroupRequest(payload) {
    return function __cancelJoinGroupRequest(_a) {
        var host = _a.host;
        var toJSON = serializer(_cancelJoinGroupRequestRequest, {}).toJSON;
        var fromJSON = serializer(_cancelJoinGroupRequestResponse, {
            _joinGroupRequest: _joinGroupRequest,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'DELETE',
            url: resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl({
                protoPath: '/v2/groups/{groupId}/join-requests',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Approves pending join group requests.
 * Group managers always have access to this functionality. In some cases, site owners will allow group members to use this functionality as well.
 */
export function approveJoinGroupRequests(payload) {
    return function __approveJoinGroupRequests(_a) {
        var host = _a.host;
        var toJSON = serializer(_approveJoinGroupRequestsRequest, {}).toJSON;
        var fromJSON = serializer(_approveJoinGroupRequestsResponse, {
            _joinGroupRequest: _joinGroupRequest,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl({
                protoPath: '/v2/groups/{groupId}/join-requests/approve',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Rejects pending join group requests.
 * Group managers always have access to this functionality. In some cases, site owners will allow group members to use this functionality as well.
 */
export function rejectJoinGroupRequests(payload) {
    return function __rejectJoinGroupRequests(_a) {
        var host = _a.host;
        var toJSON = serializer(_rejectJoinGroupRequestsRequest, {}).toJSON;
        var fromJSON = serializer(_rejectJoinGroupRequestsResponse, {
            _joinGroupRequest: _joinGroupRequest,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl({
                protoPath: '/v2/groups/{groupId}/join-requests/reject',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Retrieves a list of up to 100 join group requests, given the provided paging.
 * Group managers always have access to this functionality (site members can access their own join group requests in the site).
 */
export function listJoinGroupRequests(payload) {
    return function __listJoinGroupRequests(_a) {
        var host = _a.host;
        var toJSON = serializer(_listJoinGroupRequestsRequest, {}).toJSON;
        var fromJSON = serializer(_listJoinGroupRequestsResponse, {
            _joinGroupRequest: _joinGroupRequest,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'GET',
            url: resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl({
                protoPath: '/v2/groups/{groupId}/join-requests',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
/**
 * Retrieves a list of up to 100 join group requests, given the provided paging and filtering.
 * Group managers always have access to this functionality (site members can access their own join group requests in the site).
 *
 * Supported fields for filtering:
 * - `status`
 *
 * No supported fields for sorting
 */
export function queryJoinGroupRequests(payload) {
    return function __queryJoinGroupRequests(_a) {
        var host = _a.host;
        var toJSON = serializer(_queryJoinGroupRequestsRequest, {}).toJSON;
        var fromJSON = serializer(_queryJoinGroupRequestsResponse, {
            _joinGroupRequest: _joinGroupRequest,
        }).fromJSON;
        var serializedData = toJSON(payload);
        var metadata = {
            method: 'POST',
            url: resolveWixSocialGroupsApiV2JoinGroupRequestsServiceUrl({
                protoPath: '/v2/groups/{groupId}/join-requests/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromJSON,
        };
        return metadata;
    };
}
//# sourceMappingURL=http.js.map